import React from "react";

const ShareIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.33203 8.66671L9.66536 6.00004L6.33203 3.33337V5.33337H0.332031V6.66671H6.33203V8.66671Z" fill="#5D737E"/>
  <path d="M7.66601 -0.000709514C6.87769 -0.00289531 6.09678 0.151364 5.3685 0.453133C4.64023 0.754902 3.97908 1.19818 3.42334 1.75729L4.36601 2.69996C5.24734 1.81862 6.41934 1.33262 7.66601 1.33262C8.91267 1.33262 10.0847 1.81862 10.966 2.69996C11.8473 3.58129 12.3333 4.75329 12.3333 5.99996C12.3333 7.24662 11.8473 8.41862 10.966 9.29996C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29996L3.42334 10.2426C4.55601 11.376 6.06267 12.0006 7.66601 12.0006C9.26934 12.0006 10.776 11.376 11.9087 10.2426C13.042 9.10996 13.6667 7.60329 13.6667 5.99996C13.6667 4.39662 13.042 2.88996 11.9087 1.75729C11.3529 1.19818 10.6918 0.754902 9.96351 0.453133C9.23524 0.151364 8.45432 -0.00289531 7.66601 -0.000709514Z" fill="#5D737E"/>
  </svg>
 
);

export default ShareIcon;
